import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components/macro";
import { Link, useLocation } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import { menuData } from "../data/MenuData";
import logoFull from "../images/logoFull.jpg";

const Nav = styled.nav`
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  z-index: 100;
  position: fixed;
  width: 100%;

  @media screen and (max-width: 768px) {
    padding: 0.75rem 1rem;
  }
`;

const NavLink = css`
  color: #faa71e;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  text-decoration: none;
`;

const Logo = styled(Link)`
  ${NavLink}
`;

const MenuButton = styled.button`
  display: none;

  @media screen and (max-width: 768px) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border: none;
    background: #0a2a4a;
    color: #ffce2d;
    border-radius: 999px;
    cursor: pointer;
    z-index: 101;
    box-shadow: 0 6px 16px rgba(10, 42, 74, 0.25);
    transition: transform 0.2s ease, background 0.2s ease;
    -webkit-tap-highlight-color: transparent;

    &:hover,
    &:focus-visible {
      background: #faa71e;
      color: #fff;
      transform: scale(1.04);
      outline: none;
    }
  }
`;

const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: -48px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const NavMenuLinks = styled(Link)`
  ${NavLink}
`;

const NavBtn = styled.div`
  display: flex;
  align-items: center;
  margin-right: 24px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const LockedBtn = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: rgba(250, 167, 30, 0.18);
  color: #b9740a;
  padding: 0.6rem 1.4rem;
  border: 1px dashed rgba(250, 167, 30, 0.7);
  border-radius: 999px;
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 0.02em;
  cursor: default;
  user-select: none;
`;

const Navbar = ({ toggle }) => {
  const [navbar, setNavbar] = useState(false);
  const location = useLocation();

  const changeBackground = () => {
    if (window.pageYOffset >= 60) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    const watchScroll = () => {
      window.addEventListener("scroll", changeBackground);
    };

    watchScroll();

    return () => {
      window.removeEventListener("scroll", changeBackground);
    };
  }, []);

  let style = {
    backgroundColor:
      navbar || location.pathname !== "/" ? "white" : "transparent",
    boxShadow:
      navbar || location.pathname !== "/"
        ? "rgba(250, 167, 30, 1) 0px 7px 29px 0px"
        : "",
    transition: "0.4s",
  };

  return (
    <Nav style={style}>
      <Logo to="/">
        <img
          src={logoFull}
          style={{ objectFit: "contain", height: "56px", width: "auto" }}
          alt="Cursa de Rățuște pe Bega"
        />
      </Logo>
      <NavMenu>
        {menuData.map((item, index) => {
          const isExternal = /^https?:/.test(item.link);
          if (isExternal) {
            return (
              <NavMenuLinks
                as="a"
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                key={index}
              >
                {item.title}
              </NavMenuLinks>
            );
          }
          return (
            <NavMenuLinks to={item.link} key={index}>
              {item.title}
            </NavMenuLinks>
          );
        })}
      </NavMenu>
      <NavBtn>
        <LockedBtn aria-disabled="true">🔒 Ne vedem la anul!</LockedBtn>
      </NavBtn>
      <MenuButton onClick={toggle} aria-label="Deschide meniu" type="button">
        <FiMenu size={24} />
      </MenuButton>
    </Nav>
  );
};

export default Navbar;
